import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

import { CircleButton } from './StaffTools.styled';

type Props = {
  content: CmsApiPage;
};

export function StaffTools({ content }: Props) {
  return (
    <CircleButton
      href={
        content.subsite
          ? `/cms/subsite/${
              content.subsite.id
            }/${content.type.toLowerCase()}s/${content.id}/edit`
          : undefined
      }
      data-qa-id="edit-button"
      aria-label={getText('Edit')}
      iconName="pencil"
    />
  );
}
